import { Column, Row } from '@melements/front-components';
import React from 'react';

import { TppInfoColumn, TppInfoLabel } from './TppInfo.styles';
import { TppInfoProps } from './TppInfo.types';

export const TppInfo = ({ label, value }: TppInfoProps) => {
  return (
    <Row>
      <Column>
        <TppInfoLabel>{label}</TppInfoLabel>
      </Column>
      <TppInfoColumn>{value}</TppInfoColumn>
    </Row>
  );
};
